import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2 mb-4"
}
const _hoisted_2 = { class: "existing-error-message" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "d-flex pa-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: [
          { title: '園日誌', href: '/school-diary', color: 'primary' },
          { title: '園日誌 作成' },
        ]
      })
    ]),
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "mb-8" }, [
      _createElementVNode("h1", null, "園日誌 作成")
    ], -1)),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _cache[5] || (_cache[5] = _createElementVNode("h4", null, "日付", -1)),
            _createVNode(_component_date_picker, {
              modelValue: _ctx.date,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.existingError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.formattedDate) + " の園日誌はすでに存在しています。 ", 1),
            _createElementVNode("a", {
              class: "ml-4",
              href: `/school-diary/edit/${_ctx.date}`
            }, "編集ページへ", 8, _hoisted_3)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "6" }, {
          default: _withCtx(() => [
            _cache[6] || (_cache[6] = _createElementVNode("h4", null, "自由記録", -1)),
            _createVNode(_component_v_textarea, {
              variant: "outlined",
              modelValue: _ctx.comment,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.comment) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "6" }, {
          default: _withCtx(() => [
            _cache[7] || (_cache[7] = _createElementVNode("h4", null, "園行事 / 来訪者", -1)),
            _createVNode(_component_v_textarea, {
              variant: "outlined",
              modelValue: _ctx.event,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.event) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "6" }, {
          default: _withCtx(() => [
            _cache[8] || (_cache[8] = _createElementVNode("h4", null, "早退者 (理由)", -1)),
            _createVNode(_component_v_textarea, {
              variant: "outlined",
              modelValue: _ctx.earlyLeaver,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.earlyLeaver) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      (_ctx.isFetching)
        ? (_openBlock(), _createBlock(_component_v_progress_linear, {
            key: 0,
            indeterminate: "",
            color: "primary",
            class: "my-8"
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_select, {
          variant: "outlined",
          label: "申請者",
          items: _ctx.staffOptions,
          "item-value": "userId",
          "item-title": "name",
          modelValue: _ctx.appliedBy,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.appliedBy) = $event))
        }, null, 8, ["items", "modelValue"]),
        _createVNode(_component_v_spacer)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        color: "primary",
        variant: "outlined",
        "x-large": "",
        disabled: _ctx.isFetching || _ctx.existingError,
        class: "mx-2",
        onClick: _ctx.createAsDraft
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
          _createTextVNode("下書きとして保存", -1)
        ]))]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_v_btn, {
        color: "primary",
        variant: "flat",
        "x-large": "",
        disabled: _ctx.isFetching || _ctx.existingError || !_ctx.appliedBy,
        class: "mx-2",
        onClick: _ctx.createAndApply
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
          _createTextVNode("保存して申請", -1)
        ]))]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_v_spacer)
    ])
  ]))
}